import React, { useState } from "react";
import { CloseButton, Offcanvas } from "react-bootstrap";
import Tick from "assets/svgs/tick";
import { buttonStyle, formRow, selected } from "modules/dashboards/feedback_form/commonFunction";
import CallResponse from "modules/dashboards/feedback_form/CallResponse";

import { Button } from 'antd';
import { formDisposition } from 'config';
import { isEmpty } from 'lodash';
import Comments from 'modules/dashboards/feedback_form/Comments';
import SaveFeedBack from 'modules/dashboards/feedback_form/SaveFeedBack';

function AdhocCallDisposition({ customerId, setData }) {
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState({ callResponse: null, comments: null });
  const renderedComponents = [
    { name: "callResponse", value: formData.callResponse },
  ];

  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
  };

  const disabledCondition = () => {
    let condition = false;
    switch(formData.callResponse){
      case 'dndMode': condition = formData.comments  && isEmpty(formData.comments)
      case 'languageIssue':condition = formData.comments  && isEmpty(formData.comments)
      default: condition = isEmpty(formData.comments)
    }
    return condition;
  };

  return (
    <>
      <Button type='primary' className="flex-1" onClick={() => handleShow("lg-down")}><Tick /></Button>
      <Offcanvas
        show={show}
        placement={"end"}
        style={{ width: "45%" }}
        onHide={handleClose}
      >
        <Offcanvas.Header CloseButton>
          <Offcanvas.Title>Add Feedback</Offcanvas.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={handleClose}
          />
        </Offcanvas.Header>
        <Offcanvas.Body
          style={{ maxHeight: "85vh", overflowY: "scroll" }}
          className="scrollable-container"
        >
          <div>
            <CallResponse
              formData={formData}
              buttonStyle={buttonStyle}
              selected={selected}
              setFormData={setFormData}
              formRow={formRow}
            />
            {formData.callResponse && <Comments 
             comment={formData?.comments}
             setFormData={setFormData}
             length={formData?.comments?.length}
            />}
            {[...formDisposition, 'answered'].includes(formData?.callResponse) && (
                <>
                  <SaveFeedBack
                      setShow={setShow}
                      setData={setData}
                      week={'ADHOC_CALL'} 
                      formData={formData}
                      customerId={customerId}
                      renderedComponents={renderedComponents}
                      disabled={isEmpty(formData.comments)}
                  />
                </>
            )}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default AdhocCallDisposition;